import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';

import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/for/default';
import DigitalOrderConfig from 'umg-ember-backend/components/record-detail/forms/digital-order-config';
import Toolbar from 'umg-ember-backend/components/record-detail/toolbar';
import Button from 'umg-ember-backend/components/ui/button';
import Window from 'umg-ember-backend/components/ui/window';
import recordHeadlineOrNew from 'umg-ember-backend/helpers/record-headline-or-new';
import recordOverline from 'umg-ember-backend/helpers/record-overline';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class RecordDetailForDigitalOrderConfigComponent extends Component {
  // Services
  @service fetch;

  // Getter and setter
  get isTestOrderDisabled() {
    return !this.args.model.articleNumber || this.testOrder.isRunning;
  }

  // Tasks
  testOrder = task(async () => {
    try {
      await this.fetch.post('/tools/testDigitalOrder', {
        data: { articleNumber: this.args.model.articleNumber },
      });

      this.flashMessages.success(
        'record_detail.for.digital_order_config.test_order_success',
      );
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  });

  // Template
  <template>
    <Window
      @onBodyScroll={{fn (mut this.scrollPosition)}}
      @scrollPosition={{this.scrollPosition}}
      @isLoading={{@model.isLoading}}
      data-test-record-detail='digital-order-config'
    >
      <:overline>
        {{recordOverline @model}}
      </:overline>

      <:title>
        {{recordHeadlineOrNew @model}}
      </:title>

      <:toolbar>
        <Toolbar
          @model={{@model}}
          @primaryActions={{hash
            onCancel=this.transitionToPrevBreadcrumb
            onPublish=(fn this.publishRecord @model)
            onSave=(fn this.saveRecord @model)
            onSaveAndUnload=(fn this.saveAndUnloadRecord @model)
          }}
          @secondaryActions={{hash
            onDeleteRecord=(fn this.deleteRecordInDetail @model)
            onForceUnlock=(fn this.forceUnlockRecord @model)
            onUnblock=(fn this.unblockRecord @model)
            onBlock=(fn this.blockRecord @model)
          }}
        >
          <:additonalPrimaryActions>
            <Button
              @label={{t 'record_detail.for.digital_order_config.test_order'}}
              @icon='play'
              @disabled={{this.isTestOrderDisabled}}
              {{on 'click' (perform this.testOrder)}}
            />
          </:additonalPrimaryActions>
        </Toolbar>
      </:toolbar>

      <:body>
        <DigitalOrderConfig
          @model={{@model}}
          @recordType={{getRecordType @model}}
          @onSaveRecord={{fn this.saveRecord @model}}
          @showErrors={{this.history.showErrors}}
        />
      </:body>
    </Window>
  </template>
}
